import { render } from "./Breadcrumb.vue?vue&type=template&id=0d47e6d0"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/Breadcrumb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d47e6d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d47e6d0', __exports__)) {
    api.reload('0d47e6d0', __exports__)
  }
  
  module.hot.accept("./Breadcrumb.vue?vue&type=template&id=0d47e6d0", () => {
    api.rerender('0d47e6d0', render)
  })

}


export default __exports__